import { useTranslation } from 'react-i18next';
import { S, Icon } from '../regureStyles';

const Header = ({ setShowConfig, fetchSignals }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{ padding: '20px 32px', borderBottom: `1px solid ${S.borderLight}`, background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(20px)', flexShrink: 0 }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 12, color: S.textMuted, marginBottom: 4 }}>{t('screens.riskSignals.headerKicker')}</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('screens.riskSignals.headerTitle')}</div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            disabled
            title={t('screens.riskSignals.configureDisabledTitle')}
            style={{
              padding: '9px 16px',
              background: S.bgCard,
              border: `1px solid ${S.borderLight}`,
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 600,
              color: '#94a3b8',
              cursor: 'not-allowed',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              opacity: 0.6,
            }}
          >
            <Icon name='settings' color='#94a3b8' size={15} />
            {t('screens.riskSignals.configure')}
          </button>
          <button
            onClick={fetchSignals}
            style={{
              padding: '9px 16px',
              background: `linear-gradient(135deg, ${S.burgundy}, #722f37)`,
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <Icon name='refresh' color='#fff' size={15} />
            {t('screens.riskSignals.refresh')}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
